<template>
  <div>
    <v-row>
      <v-col>
        <AddProduct @input="addProduct" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs
          v-model="activeTab"
          class="ml-1 my-2"
        >
          <v-tab
            v-for="type in productsByTypes"
            :key="type.id"
          >
            {{ type.title }}
          </v-tab>
        </v-tabs>

        <v-tabs-items
          v-model="activeTab"
        >
          <v-tab-item
            v-for="type in productsByTypes"
            :key="type.id"
          >
            <v-card
              text
              flat
            >
              <ClientProduct
                v-for="(product, index) in getProductByType(type.id)"
                :id="clientId"
                :key="`${product.key}-product-${index}`"
                :item="product"
                @remove="removeProduct(product.product.id)"
                @updateJiraKey="updateJiraKey"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ClientProduct from "./ClientProduct.vue";
import AddProduct from "./AddProduct.vue";
import { productTypes } from "@/helpers";

export default {
  components: {
    ClientProduct,
    AddProduct,
  },
  props: ["value", "clientId"],
  data: () => ({
    activeTab: "",
  }),
  computed: {
    productsByTypes(){
      return [
        {
          id: productTypes.SOFTWARE.value,
          title: productTypes.SOFTWARE.title,
          key: "software",
        },
        {
          id: productTypes.LICENSE.value,
          title: productTypes.LICENSE.title,
          key: "license",
        },
        {
          id: productTypes.OTHER.value,
          title: productTypes.OTHER.title,
          key: "other",
        },
      ].filter(el => this.value.some(item => item.type === el.id));
    },
  },
  methods: {
    removeProduct(id) {
      const products = this.value.filter(({ product }) => product.id !== id);
      this.updateValue(products);
    },
    updateValue(value) {
      this.$emit("input", value);
    },
    setActiveTab(id) {
      this.activeTab = id;
    },
    getProductByType(id) {
      return this.value.filter(({ type }) => type === id);
    },
    addProduct(product) {
      const products = [...this.value, {
        product: {
          id: product.product.id,
          title: product.product.title,
        },
        actualVersion: product.product.actualVersion?.version ?? "",
        versions: product.product.productVersions
          ? product.product.productVersions.map((p) => p.version)
          : [],
        regNumber: product.regNumber,
        updateByClient: product.updateByClient,
        version: product.version,
        notes: product.notes,
        type: product.type,
        trackVersions: product.trackVersions,
      }];
      this.setActiveTab(product.type);
      this.updateValue(products);
    },
    updateJiraKey(key, id){
      const product = this.value.filter(item => item.product.id === id);
      product.jiraIssueKey = key;
      this.updateValue(this.value);
    },
  },
};
</script>
